<template>
    <app-layout class="location-container">
        <common-page-plain>
            <common-content-spacer height="large">
                <common-content-wrapper width="medium">
                    <div class="location-container--header">
                        <common-icon name="location" size="gigantic"></common-icon>
                        <span class="practice-information-form__main-location-header">Locations</span>
                    </div>
                    <practice-location-form></practice-location-form>
                </common-content-wrapper>
            </common-content-spacer>
        </common-page-plain>
    </app-layout>
</template>

<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PracticeLocationForm from 'components/forms/practice/PracticeLocationForm'

    export default {
        components: {
            AppLayout,
            PracticeLocationForm,
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/practice-locations/_practice-locations.scss';
</style>
